/*
 * Luxgear pre-checkout gate. It fails closed when cart data or the approved
 * variant asset is unavailable, so an unvalidated item never reaches checkout.
 */
(function () {
  'use strict';

  var ADDRESS_CHECK_PATH = '/pages/address-check';
  var PRODUCT_PATH_PREFIX = '/products/';
  var statusId = 'luxgear-address-gate-status';
  var redirecting = false;

  if (window.location.pathname === ADDRESS_CHECK_PATH || window.location.pathname.indexOf('/checkout') === 0) {
    return;
  }

  function approvedVariants() {
    var ids = window.__LUXGEAR_ALLOWED_VARIANT_IDS__;
    if (!Array.isArray(ids)) return null;
    return new Set(ids.map(String));
  }

  function trackInitiateCheckout(items) {
    var totalQuantity = (items || []).reduce(function (sum, item) {
      return sum + Number(item.quantity || 0);
    }, 0);
    var contentIds = (items || []).map(function (item) {
      return String(item.variant_id || item.id || '');
    }).filter(Boolean);
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'InitiateCheckout', {
        content_ids: contentIds,
        content_type: 'product',
        num_items: totalQuantity
      });
      return;
    }
    var params = new URLSearchParams({
      id: '2104510900331758',
      ev: 'InitiateCheckout',
      dl: window.location.href,
      rl: document.referrer,
      if: 'false',
      ts: String(Date.now()),
      v: '2.9.349',
      noscript: '1',
      cd: JSON.stringify({ content_ids: contentIds, content_type: 'product', num_items: totalQuantity })
    });
    try {
      navigator.sendBeacon('https://www.facebook.com/tr/?' + params.toString());
    } catch (error) {
      (new Image()).src = 'https://www.facebook.com/tr/?' + params.toString();
    }
  }

  function statusElement() {
    var element = document.getElementById(statusId);
    if (element) return element;

    element = document.createElement('div');
    element.id = statusId;
    element.className = 'luxgear-address-gate__status';
    element.setAttribute('role', 'alert');
    element.setAttribute('tabindex', '-1');
    document.body.insertAdjacentElement('afterbegin', element);
    return element;
  }

  function showError(message) {
    var element = statusElement();
    element.textContent = message;
    element.hidden = false;
    element.focus({ preventScroll: false });
  }

  function appendStyles() {
    if (document.getElementById('luxgear-address-gate-styles')) return;
    var style = document.createElement('style');
    style.id = 'luxgear-address-gate-styles';
    style.textContent = [
      '.luxgear-address-gate__status{position:fixed;z-index:1000;top:1.6rem;left:50%;width:min(48rem,calc(100% - 3.2rem));transform:translateX(-50%);padding:1.2rem 1.6rem;border:.1rem solid rgb(var(--color-foreground));border-radius:var(--inputs-radius);background:rgb(var(--color-background));color:rgb(var(--color-foreground));box-shadow:0 .4rem 1.4rem rgba(var(--color-shadow),.2);font:inherit}',
      '.luxgear-address-gate__buy-now{min-height:4.4rem;margin-top:1.2rem}',
      '.luxgear-address-gate__buy-now:focus-visible{outline:.2rem solid currentColor;outline-offset:.3rem}'
    ].join('');
    document.head.appendChild(style);
  }

  function validLineItem(variantId, quantity, allowed) {
    return /^\d+$/.test(String(variantId)) && Number.isSafeInteger(quantity) && quantity > 0 && allowed.has(String(variantId));
  }

  function checkoutCartState(cart) {
    var allowed = approvedVariants();
    if (!allowed) {
      showError('Checkout is temporarily unavailable because product eligibility could not be verified. Please refresh and try again.');
      return null;
    }
    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
      showError('Your cart is empty. Add an approved product before checking out.');
      return null;
    }

    var lines = [];
    for (var index = 0; index < cart.items.length; index += 1) {
      var item = cart.items[index] || {};
      var variantId = String(item.variant_id || item.id || '');
      var quantity = Number(item.quantity);
      if (!validLineItem(variantId, quantity, allowed)) {
        showError('This cart contains a product that is not available for checkout. Remove it from your cart and try again.');
        return null;
      }
      lines.push(variantId + ':' + quantity);
    }
    return {
      variants: lines.join(','),
      cartToken: typeof cart.token === 'string' ? cart.token : '',
      items: cart.items
    };
  }

  function redirectToAddressCheck(state) {
    if (!state || !state.variants || redirecting) return;
    redirecting = true;
    var params = new URLSearchParams({ variants: state.variants });
    if (state.cartToken) params.set('cart_token', state.cartToken);
    if (state.productPath && /^\/products\/[a-z0-9][a-z0-9-]*\/?$/i.test(state.productPath)) {
      params.set('product_path', state.productPath.replace(/\/$/, ''));
    }
    trackInitiateCheckout(state.items);
    window.location.assign(ADDRESS_CHECK_PATH + '?' + params.toString());
  }

  function fetchCartAndRedirect() {
    if (redirecting) return;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('cart request failed');
        return response.json();
      })
      .then(function (cart) {
        var state = checkoutCartState(cart);
        if (state) redirectToAddressCheck(state);
      })
      .catch(function () {
        showError('We could not verify your cart. Please refresh the page and try checkout again.');
      });
  }

  function selectedProductLine() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return null;

    var variantInput = form.querySelector('[name="id"]');
    if (!variantInput || !variantInput.value) return null;

    var quantityInput = form.querySelector('[name="quantity"]');
    var quantity = quantityInput ? Number(quantityInput.value) : 1;
    return { variant_id: variantInput.value, quantity: quantity };
  }

  function redirectSelectedProduct() {
    var product = selectedProductLine();
    var allowed = approvedVariants();
    if (!product || !allowed || !validLineItem(product.variant_id, Number(product.quantity), allowed)) {
      showError('This product is not available for checkout. Select an approved variant and quantity, then try again.');
      return;
    }
    redirectToAddressCheck({ variants: String(product.variant_id) + ':' + Number(product.quantity), cartToken: '', productPath: window.location.pathname, items: [product] });
  }

  function closestCheckoutControl(target) {
    if (!(target instanceof Element)) return null;
    return target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"], .shopify-payment-button__button');
  }

  function controlIsDynamicBuyNow(control) {
    return control && control.classList.contains('shopify-payment-button__button');
  }

  function installDynamicBuyNowReplacement() {
    if (window.location.pathname.indexOf(PRODUCT_PATH_PREFIX) !== 0) return false;
    var containers = document.querySelectorAll('.shopify-payment-button, .dynamic-checkout-buttons');
    if (!containers.length) return false;

    containers.forEach(function (container) {
      if (container.dataset.luxgearAddressGate === 'installed') return;
      container.dataset.luxgearAddressGate = 'installed';
      container.hidden = true;
      container.setAttribute('aria-hidden', 'true');

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'button button--full-width button--secondary luxgear-address-gate__buy-now';
      button.textContent = 'Buy it now';
      button.addEventListener('click', function () {
        redirectSelectedProduct();
      });
      container.insertAdjacentElement('afterend', button);
    });
    return true;
  }

  function interceptCheckoutClick(event) {
    var control = closestCheckoutControl(event.target);
    if (!control) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (window.location.pathname.indexOf(PRODUCT_PATH_PREFIX) === 0 && controlIsDynamicBuyNow(control)) {
      redirectSelectedProduct();
      return;
    }
    fetchCartAndRedirect();
  }

  function interceptCheckoutSubmit(event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/checkout') === -1) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    fetchCartAndRedirect();
  }

  appendStyles();
  document.addEventListener('click', interceptCheckoutClick, true);
  document.addEventListener('submit', interceptCheckoutSubmit, true);

  if (!installDynamicBuyNowReplacement() && window.location.pathname.indexOf(PRODUCT_PATH_PREFIX) === 0) {
    var observer = new MutationObserver(function () {
      if (installDynamicBuyNowReplacement()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 15000);
  }
}());
